import { LoadableAfterPaint } from '@confluence/loadable';

export const RtPaidFeatureEducationSpotlightLoadable = LoadableAfterPaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-RtPaidFeatureEducationSpotlight" */ '../../src/ui/RtPaidFeatureEducationSpotlight.tsx'
			)
		).RtPaidFeatureEducationSpotlight,
});
